export default "__VITE_ASSET__Cnl9RJCU__"